/* INTENTION — free-shipping thresholds, the behaviour half.
   Extracted from the inline <script> in snippets/int-shipping-thresholds.liquid
   on 2026-09-12. Loaded with defer from that snippet, directly after the
   #int-ship-cfg JSON island it reads.

   ⛔ NO NUMBER MAY EVER BE WRITTEN IN THIS FILE. Every shipping figure (the 16
   bars, the 64 tier rates, the weight bounds and the bundle rule) lives in the
   Liquid arrays in int-shipping-thresholds.liquid and reaches this file only
   through #int-ship-cfg, so Liquid and JavaScript still cannot drift apart.
   The rules those numbers follow are written at the top of that snippet.
   A .js asset is never Liquid parsed, which is exactly why the island exists.

   ⚑ WHY defer IS SAFE HERE, checked over the whole theme 2026-09-12.
   Every consumer of these globals is guarded and none of them runs at parse
   time: assets/int-region-card.js is itself deferred and its tag comes LATER in
   the document, so it runs after this one; assets/int-collection-bands.js runs
   long after DOMContentLoaded; assets/searchanise-navigation.js runs on
   interaction; snippets/intention-dynamic-shipping.liquid is unreferenced, and
   retries on a timer regardless. Under defer, readyState is already past
   'loading', so paint() runs at once against a complete DOM instead of waiting
   for DOMContentLoaded as the inline version had to.
   ⚠️ If a future change adds a consumer that reads these globals during parse,
   this tag has to go back to a blocking one. */
(function () {
  if (window.__intShipThresholds) return;

  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('int-ship-cfg') || {}).textContent || '{}'); } catch (e) {}
  if (!CFG.thresholds || !CFG.rates) return;

  /* Printed from the Liquid arrays — do not edit here. */
  var T = CFG.thresholds;
  window.__intShipThresholds = T;

  /* The cheapest rate per currency, same source, same order. */
  var F = CFG.rates;
  window.__intShipFromTable = F;

  /* The weight ladders, same source. assets/int-delivery-estimate.js reads the
     island itself because it runs before this deferred file; this global is for
     anything that runs later. */
  window.__intShipTiers = CFG.tiers || null;

  /* RULE 4 (2026-09-24, Nils): 2 or more pieces ship apparel and accessories
     free. Enforced at checkout by automatic free shipping discounts with a
     maximum shipping price cap, so it frees the apparel parcel and never the
     framed one. A gift card counts as a piece (the discount has no product
     scope), so pieces is the cart's item_count, every line. */
  var B = CFG.bundle || {};
  var MIN_PIECES = (typeof B.minPieces === 'number' && B.minPieces > 0) ? B.minPieces : null;
  window.__intShipBundle = {
    minPieces: MIN_PIECES,
    capEur: B.capEur,
    capEurByCountry: B.capEurByCountry || {},
    applies: function (pieces) {
      return MIN_PIECES !== null && typeof pieces === 'number' && pieces >= MIN_PIECES;
    }
  };

  function activeCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    } catch (e) {}
    return 'EUR';
  }

  /* Whole units, no decimals — these thresholds are always round numbers and
     "€69" reads better than "€69.00". Defers to the Ready Callback's formatter
     so the symbol placement matches the shipping line in the cart drawer. */
  function fmt(minorUnits, currency) {
    var major = Math.round((minorUnits || 0) / 100);
    try {
      if (typeof window.__intFormatCurrency === 'function') {
        return window.__intFormatCurrency(major, currency).replace(/[.,]00$/, '');
      }
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(major);
    } catch (e) {
      return major + ' ' + currency;
    }
  }
  window.__intShipFormat = fmt;

  /* A RATE is not a threshold: 6.95 must not print as 7. Whole numbers still print whole. */
  function fmtExact(minorUnits, currency) {
    var major = (minorUnits || 0) / 100;
    var whole = major === Math.round(major);
    try {
      /* Same formatter the threshold uses, or "from" prints DKK 49 next to a
         threshold that prints kr 499. Measured on the draft 2026-09-06. */
      if (typeof window.__intFormatCurrency === 'function') {
        var t = window.__intFormatCurrency(major, currency);
        return whole ? String(t).replace(/[.,]00$/, '') : t;
      }
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(major);
    } catch (e) {
      return major + ' ' + currency;
    }
  }
  window.__intShipFromText = function (currency, hasWallArt) {
    var cur = (currency || activeCurrency()).toUpperCase();
    var table = hasWallArt ? F.wallart : F.apparel;
    var cents = table[cur];
    if (cents == null) { cur = 'EUR'; cents = table.EUR; }
    return { cents: cents, currency: cur, text: fmtExact(cents, cur) };
  };

  window.__intFreeShipFrom = function (currency, hasWallArt) {
    var cur = (currency || activeCurrency()).toUpperCase();
    var table = hasWallArt ? T.wallart : T.apparel;
    var cents = table[cur];
    if (cents == null) { cur = 'EUR'; cents = table.EUR; }
    return { cents: cents, currency: cur, text: fmt(cents, cur) };
  };

  /* Does the CURRENT cart contain a Wall Art item? Read from the state the
     Ready Callback publishes, so we never fetch twice, then from the cart the
     theme already holds. Null = not known yet, which the 'auto' mode treats as
     "assume it might", the safe direction. */
  function cartHasWallArt() {
    var st = window.__intShippingState;
    if (st && st.profiles && st.profiles.framed) return !!st.profiles.framed.present;
    var c = window.__intCartCache;
    if (c && c.items) {
      for (var i = 0; i < c.items.length; i++) {
        if (c.items[i].product_type === 'Framed print') return true;
      }
      return false;
    }
    return null;
  }

  /* How many pieces are in the cart, for rule 4. Null = not known yet. */
  function cartPieces() {
    var c = window.__intCartCache;
    if (c && typeof c.item_count === 'number') return c.item_count;
    return null;
  }
  window.__intCartPieces = cartPieces;

  /* The "from" hook, same mode grammar as data-int-freeship. */
  function paintFrom(root) {
    var nodes = (root || document).querySelectorAll('[data-int-shipfrom]');
    if (!nodes.length) return;
    var cur = activeCurrency();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var mode = (el.getAttribute('data-int-shipfrom') || 'both').toLowerCase();
      var out;
      if (mode === 'apparel') {
        out = window.__intShipFromText(cur, false).text;
      } else if (mode === 'wallart') {
        out = window.__intShipFromText(cur, true).text;
      } else {
        var a = window.__intShipFromText(cur, false).text;
        var w = window.__intShipFromText(cur, true).text;
        var tpl = el.getAttribute('data-int-shipfrom-both') || CFG.bothTpl || '{apparel} ({wallart} on Wall Art)'; /* 2026-10-06: CFG.bothTpl = int_sidebar.ship_both_tpl, the line in the visitor's language */
        out = tpl.replace('{apparel}', a).replace('{wallart}', w);
      }
      if (el.textContent !== out) el.textContent = out;
    }
  }
  window.__intPaintShipFrom = paintFrom;

  function paint(root) {
    paintFrom(root);
    var nodes = (root || document).querySelectorAll('[data-int-freeship]');
    if (!nodes.length) return;
    var cur = activeCurrency();
    var wall = cartHasWallArt();
    var pieces = cartPieces();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var mode = (el.getAttribute('data-int-freeship') || 'both').toLowerCase();
      var out;
      var state = '';

      if (mode === 'apparel') {
        out = window.__intFreeShipFrom(cur, false).text;
      } else if (mode === 'wallart') {
        out = window.__intFreeShipFrom(cur, true).text;
      } else if (mode === 'auto') {
        /* "The bar for everything in this cart to ship free."
           CHANGED 2026-09-25 (rule 3 and 4 in the snippet). A print no longer
           raises the bar for the apparel beside it: each parcel has its own.
           - print in the cart, or cart not known yet: the Wall Art number, the
             framed parcel's own bar and the last one to free. Unknown still
             quotes the higher number, never promise the lower one.
           - no print: the apparel number. With 2 or more pieces the apparel
             parcel already ships free (rule 4); the wording for that is
             phase 3, so the number stays and the element is marked
             data-int-freeship-state="bundle" for the copy to hook onto. */
        out = window.__intFreeShipFrom(cur, wall === null ? true : wall).text;
        if (wall === false && window.__intShipBundle.applies(pieces)) state = 'bundle';
      } else {
        var a = window.__intFreeShipFrom(cur, false).text;
        var w = window.__intFreeShipFrom(cur, true).text;
        var tpl = el.getAttribute('data-int-freeship-both') || CFG.bothTpl || '{apparel} ({wallart} on Wall Art)';
        out = tpl.replace('{apparel}', a).replace('{wallart}', w);
      }

      if (el.textContent !== out) el.textContent = out;
      if (state) {
        if (el.getAttribute('data-int-freeship-state') !== state) el.setAttribute('data-int-freeship-state', state);
      } else if (el.hasAttribute('data-int-freeship-state')) {
        el.removeAttribute('data-int-freeship-state');
      }
    }
  }
  window.__intPaintFreeShip = paint;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else {
    paint();
  }

  /* ⚑ THE MONEY FORMATTER MAY BE REASSIGNED AFTER US. snippets/int-money-format.liquid
     now defines `__intFormatCurrency` synchronously in <head>, but the Rebuy Ready
     Callback is global to the shop and can assign over it when Smart Cart V2
     finishes initialising, which is async and outside our control.

     What that cost before the formatter moved into the theme: on a collection
     sidebar the line painted "DKK 499 (DKK 1,099 on Wall Art)" from the Intl
     fallback and stayed that way, while the next load of the same page showed
     "kr 499 (kr 1.099 on Wall Art)". Both measured.

     ⛔ Do NOT "fix" this by polling `typeof window.__intFormatCurrency`. It was
     already 'function' at first paint in the failing case. A timed repaint
     schedule was also tried and did not catch it either: at 5s the line was
     still DKK. Watch for the ASSIGNMENT instead, which is the only moment that
     actually matters.

     The property is redefined with a setter so any later assignment repaints
     once. If another script redefines it after us we simply lose the hook and
     fall back to the timers below, which is why both are here. */
  try {
    var __intFmt = window.__intFormatCurrency;
    Object.defineProperty(window, '__intFormatCurrency', {
      configurable: true,
      get: function () { return __intFmt; },
      set: function (v) {
        __intFmt = v;
        setTimeout(function () { try { paint(); } catch (e) {} }, 0);
      }
    });
  } catch (e) {}

  /* Belt and braces. paint() only writes when the text actually differs, so
     these cost nothing once the output has settled, and nothing is left
     running after 8s. */
  [300, 1000, 2500, 5000, 8000].forEach(function (ms) {
    setTimeout(function () { try { paint(); } catch (e) {} }, ms);
  });

  /* Repaint when the cart changes what "auto" should say, when the market
     changes the currency, and when Rebuy re-renders the drawer. */
  ['int:shipping:updated', 'theme:cart:change', 'currency:changed'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(function () { paint(); }, 60); });
  });
})();
